// The assistant is instructed (see config.chatbot.systemPrompt) to wrap every
// card name in double brackets, e.g. [[Sol Ring]]. Matching card names in free
// prose instead would either miss cards we don't already have on screen — which
// is exactly the interesting case — or link things that aren't cards.
const CARD_TOKEN = /\[\[([^[\]]+)\]\]/g;

export const findCardUrl = name =>
  `${process.env.PUBLIC_URL}/findcard?name=${encodeURIComponent(name.trim())}`;

/**
 * Rewrites [[Card Name]] tokens into markdown links to our own card search, so
 * react-markdown renders them as anchors.
 */
export const linkifyCardNames = text => {
  if (!text) return '';
  return text.replace(CARD_TOKEN, (match, name) => {
    const label = name.trim();
    if (!label) return match;
    // Escape the label's own brackets so it can't break out of the link syntax.
    const safeLabel = label.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    return `[${safeLabel}](${findCardUrl(label)})`;
  });
};

/**
 * The card name back out of a link this module produced, or null for any other
 * URL the assistant may have written. Used to decide which links get a card
 * preview on hover.
 */
export const cardNameFromUrl = href => {
  if (!href) return null;
  const match = /[?&]name=([^&]+)/.exec(href);
  if (!match || !href.includes('/findcard')) return null;
  try {
    return decodeURIComponent(match[1].replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
};

const chatCardLinks = { findCardUrl, linkifyCardNames, cardNameFromUrl };

export default chatCardLinks;
